import { z } from 'zod';
import { dateRangeStringSchema } from '@/lib/date-schema';

export const projectAboutFormSchema = z.object({
  title: z.string().min(1, "Título é obrigatório"),
  salicNumber: z.string().min(1, "Número do SALIC é obrigatório"),
  proponent: z.string().min(1, "Proponente é obrigatório"),
  cnpjProponent: z.string().min(1, "CNPJ do proponente é obrigatório"),
  releaseDate: dateRangeStringSchema,
  episodeCount: z.string().optional(),
  episodeDuration: z.string().optional(),
  segment: z.string().optional(),
  genre: z.string().min(1, "Gênero é obrigatório"),
  format: z.string().optional(),
  logline: z.string().min(1, "Logline é obrigatória"),
  sanfom_number: z.string().optional(),
});

export type ProjectAboutFormData = z.infer<typeof projectAboutFormSchema>;